/**
 * Marks a `$t(...)` target as already absolute (a full storage key such as `scope.id.some.key`) so that scope
 * qualification leaves it alone. `ref()` emits it and `qualifyNestings` strips it.
 */
export const ABSOLUTE_NESTING_MARKER = `@@`;

const NESTING_PATTERN = /(@@)?\$t\(\s*([^,)\s]+)/g;

/**
 * Rewrites every `$t(key)` in a scope's English text to `$t(<scopeId>.key)`, so nesting resolves inside the scope.
 * Targets prefixed with the absolute marker (see `ref()`) are kept as written, minus the marker.
 */
export function qualifyNestings(text: string, scopeId: string): string {
  return text.replace(NESTING_PATTERN, (_match, absoluteMarker: string | undefined, key: string) =>
    absoluteMarker ? `$t(${key}` : `$t(${scopeId}.${key}`,
  );
}
